/* Deterministic ids.
 *
 * The demo numbered its records ('m1000', 'l200'). The schema in MIGRATION.md §4 keys
 * everything by uuid, so the seed has to deal uuids — and they have to be the SAME uuids
 * on every build, or nothing about the demo is reproducible and no test can name a row.
 *
 * So an id is a pure function of a namespaced key: uuidFrom('member:0') is always the
 * same uuid. Nothing here consumes the RNG, which means adding a pass that needs an id
 * cannot shift the deal for everything after it. */
function fnv1a(s, basis) {
    let h = basis >>> 0;
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h >>> 0;
}
/** 128 bits of hex out of 64 bits of key hash: far more headroom than the few thousand
 *  ids one gym needs, and stable across machines because it is only integer arithmetic. */
export function uuidFrom(key) {
    let a = fnv1a(key, 0x811c9dc5);
    let b = fnv1a(key + '', 0x9e3779b1);
    const bytes = [];
    for (let i = 0; i < 16; i++) {
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        b = (b ^ t) >>> 0;
        b = Math.imul(b ^ (b >>> 13), 0x85ebca6b) >>> 0;
        bytes.push((b ^ (b >>> 16)) & 0xff);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4 shape
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant
    const hex = bytes.map((x) => x.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
/* Staff are identified BY NAME everywhere in the demo ('Coach Dana R.' on a member's
   support_coach, on an anchor, on a note), and myScope() in the old util.js matched a
   login to their book by that string. One function turns the name into the id, so the
   Support Coach login's user id and the support_coach_id on her members are the same
   value without anything having to be wired up. */
export const staffId = (name) => uuidFrom('staff:' + name);
export const memberId = (i) => uuidFrom('member:' + i);
export const leadId = (i) => uuidFrom('lead:' + i);
export const classId = (i) => uuidFrom('class:' + i);
